import React from 'react';
import './header-styles.css';
export const Header = () => {
  return (
   <>
    <div className='container' style={{display:"none"}}>
      <img className='logo' src={require('../../assets/app-logo.png')} />
      {/* <span className='app-name'>Reid Health</span> */}
    </div>
   </>
  );
};
